import { enumToEnumNames } from '@commonClient2/services/enums';
// eslint-disable-next-line import/prefer-default-export
const UNSUBMITTED = 'Unsubmitted';
const SUBMITTED = 'Submitted';
const UNAWARDED = 'Unawarded';
const APPROVED = 'Approved';
const REFUSED = 'Refused';
const DECLINED = 'Declined';

export const EmployeeBiddingStatus = Object.freeze({
    [UNSUBMITTED]: 0,
    [SUBMITTED]: 1,
    [UNAWARDED]: 2,
    [APPROVED]: 3,
    [REFUSED]: 4,
    [DECLINED]: 5,
});
export const EmployeeBiddingStatusNames = enumToEnumNames(EmployeeBiddingStatus);
export default EmployeeBiddingStatus;
